module.exports = __webpack_public_path__ + "static/media/networking.51707e46.jpg";